document.addEventListener('submit', async event => {
  const form = event.target.closest('form[data-wh-add]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button.disabled) return;
  const status = form.querySelector('.wh-add-status');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  status.textContent = '';
  try {
    const response = await fetch(form.action.replace(/\/add\/?$/, '/add.js'), {
      method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || status.dataset.error);
    if (form.closest('.wh-threads')) status.textContent = 'Added to bag';
    if (window.cartUpsell?.openCart) await window.cartUpsell.openCart(button);
    else if (!form.closest('.wh-threads')) window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
  } catch (error) {
    status.textContent = error.message || status.dataset.error;
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});

// The Shopify Forms teaser lives in its own open shadow root.
// Scope the compact treatment to Passing notes, on mobile homepages only.
(() => {
  const hostId = 'app-embed-container-1223347';
  const styleId = 'waite-compact-passing-notes';
  let attempts = 0;
  const apply = () => {
    const root = document.getElementById(hostId)?.shadowRoot;
    if (!root) return false;
    if (root.getElementById(styleId)) return true;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `@media(max-width:749px){
      #app-embed[data-current-step="tease"]{--app-embed-padding-x:8px;--app-embed-padding-y:8px}
      button[data-testid="form-teaser"][aria-label="Passing notes"]{min-height:44px!important;height:44px!important;width:auto!important;max-width:150px!important;padding:8px 34px 8px 12px!important;border-radius:999px!important}
      button[data-testid="form-teaser"][aria-label="Passing notes"] h3{font-size:14px!important;line-height:1.2!important;margin:0!important;white-space:nowrap!important}
      button[data-testid="form-teaser"][aria-label="Passing notes"] [aria-label="Close modal"]{width:28px!important;height:28px!important;right:3px!important;top:8px!important;display:flex!important;align-items:center!important;justify-content:center!important}
    }`;
    root.appendChild(style);
    return true;
  };
  if (apply()) return;
  const timer = setInterval(() => { if (apply() || ++attempts >= 60) clearInterval(timer); }, 500);
})();

// Keep conversation indicators in sync with native swiping.
function initWaiteThreads(scope = document) {
  scope.querySelectorAll('[data-wh-threads]').forEach(section => {
    if (section.dataset.whBound) return;
    section.dataset.whBound = 'true';
    const rail = section.querySelector('.wh-thread-rail');
    const cards = [...rail.querySelectorAll('.wh-thread')];
    const dots = [...section.querySelectorAll('[data-wh-thread-dot]')];
    if (!cards.length) return;
    const update = () => {
      const start = cards[0].offsetLeft;
      let nearest = 0;
      cards.forEach((card, index) => {
        if (Math.abs(card.offsetLeft - start - rail.scrollLeft) < Math.abs(cards[nearest].offsetLeft - start - rail.scrollLeft)) nearest = index;
      });
      dots.forEach((dot,index) => { if(index === nearest) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
    };
    dots.forEach((dot,index) => dot.addEventListener('click', () => rail.scrollTo({left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'})));
    let scheduled = false;
    rail.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { update(); scheduled = false; }); } }, {passive:true});
    update();
  });
}
initWaiteThreads();
document.addEventListener('shopify:section:load', event => initWaiteThreads(event.target));
